/* tslint:disable */
/* eslint-disable */
import { exists } from '../runtime';
/**
 * @export
 * @interface ConfirmEmailRequest
 */
export interface ConfirmEmailRequest {
    userId?: string | null;
    code?: string | null;
}

export function ConfirmEmailRequestFromJSON(json: any): ConfirmEmailRequest {
    return ConfirmEmailRequestFromJSONTyped(json, false);
}

export function ConfirmEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmEmailRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': !exists(json, 'user_id') ? undefined : json['user_id'],
        'code': !exists(json, 'code') ? undefined : json['code'],
    };
}

export function ConfirmEmailRequestToJSON(value?: ConfirmEmailRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'user_id': value.userId,
        'code': value.code,
    };
}
